<flx-modal
  [dismissible]="false"
  class="flx-ds large dark"
>
  <div
    class="flx-modal-title text-neutral-50"
    flxModalHeaderTitle
  >
    Edit Generated Data Model Keys
  </div>
  <div
    class="flx-modal-subtitle text-neutral-400"
    flxModalHeaderSubtitle
  >
    You can edit keys or opt out of generating keys for generated code
  </div>

  <form
    [formGroup]="rootForm"
    class="flx-modal-body"
  >
    <div
      class="flex flex-col gap-2 text-neutral-50"
      formArrayName="items"
    >
      @for (model of items; track model.row.id) {
        <div
          [formGroupName]="$index"
          [class.opacity-30]="!formArray.at($index).controls.active.value"
          [class.ml-8]="model.row.parentId"
          class="has-[flx-data-model-autocomplete.error-required]:mb-8 has-[flx-data-model-autocomplete.error-wrong-type]:mb-8 flex items-center flex gap-2 align-center data-model-form"
        >
          <flx-checkbox formControlName="active" />

          <span
            [class.w-48]="!model.row.parentId"
            [class.w-40]="model.row.parentId"
            class="text-sm text-white truncate"
            >{{ model.row.label ?? model.row.key }}</span
          >

          <div class="relative flex flex-1 justify-between items-center">
            <!-- key field, with the source colour as a left accent -->
            <div
              class="flex flex-1 min-w-0 items-center overflow-hidden rounded-md border border-neutral-600 bg-neutral-900"
            >
              <div
                [ngClass]="sourceMarkerClass[model.row.source]"
                class="self-stretch w-1.5 shrink-0 my-0.5 ml-0.5 rounded-l"
              ></div>

              @if (model.row.keyAutocomplete) {
                <flx-data-model-autocomplete
                  [selectedTemplateConfig]="{
                    componentIdentifier: model.row.keyAutocomplete.componentIdentifier,
                    key: model.form.controls.key.value,
                  }"
                  [class.error-required]="formArray.at($index).controls.key.errors?.required"
                  class="h-[26px] w-full"
                  formControlName="key"
                  type="input"
                />
              } @else {
                <input
                  class="w-full bg-transparent px-3 py-1.5 text-sm text-white placeholder:text-neutral-500 outline-none"
                  formControlName="key"
                  placeholder="Key path…"
                />
              }
            </div>

            @if (formArray.at($index).controls.key.errors?.required) {
              <flx-error>Field is required</flx-error>
            }
            @if (model.row.unresolved) {
              <flx-error>{{ referenceUnresolvedMessage }}</flx-error>
            }
          </div>

          <div
            [ngClass]="statusBadge[model.status].class"
            class="h-[26px] flex gap-1 justify-center items-center w-20 p-1 rounded text-xs text-white"
          >
            {{ statusBadge[model.status].label }}
            <flx-icon
              [pTooltip]="statusBadge[model.status].tooltip"
              name="info"
              class="opacity-30"
              tooltipPosition="top"
            />
          </div>

          <span class="w-24 px-2 py-1 text-xs lowercase"
            >{{ model.type }} {{ model.row.multiInstance ? '[]' : '' }}</span
          >

          <flx-input class="flx-ds flex-1">
            <input
              flxInput
              placeholder="Set a description..."
              formControlName="description"
            />
          </flx-input>
        </div>
      }
    </div>
  </form>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__left flex items-center gap-4 text-xs text-neutral-400">
      @for (entry of legend; track entry.source) {
        <span class="flex items-center gap-1">
          <span
            [ngClass]="sourceMarkerClass[entry.source]"
            class="h-[10px] w-[10px] rounded-sm"
          ></span>
          {{ entry.label }}
        </span>
      }
    </div>

    <div class="flx-modal-footer__right">
      <button
        (click)="close()"
        class="flx-ds secondary"
        flxButton
        type="button"
      >
        Back
      </button>
      <button
        [disabled]="!canSave()"
        (click)="save()"
        class="flx-ds primary"
        flxButton
        type="button"
      >
        Save & Close
      </button>
    </div>
  </div>
</flx-modal>
